module.exports = __webpack_public_path__ + "static/media/b.8bb2b26f.png";